import axios from 'axios';

const PAGEVIEW_ANALYTICS_URL = import.meta.env.VITE_PAGEVIEW_ANALYTICS_URL;

const pageviewAnalyticsClient = axios.create({
    baseURL: PAGEVIEW_ANALYTICS_URL,
    headers: { 'Content-Type': 'application/json' },
});

export default pageviewAnalyticsClient;
